<template>
  <section>
    <the-title title=" my blogs" backTitle="Blog"></the-title>
  </section>
</template>


<style lang="scss" scoped>
  section{
    min-height: 100vh;
  }
</style>